import { Component, OnInit, TemplateRef, ViewChild, EventEmitter, Output, OnDestroy } from '@angular/core';
import { NgbModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { GlobalConstants } from '../../../constants/global.constant';
import { AssetLibraryConstants } from '../../../../core/routing/services/asset-library/constants/asset-library.constant';
import { environment } from '../../../../../environments/environment';
import { AttractorLoop, AttractorLoopConfiguration } from '../../../../modules/asset-library/attractor-loop/interfaces/attractor-loop.i';
import { AttractorLoopService } from '../../../../core/routing/services/asset-library/attractor-loop.service';
import { Subject } from 'rxjs/internal/Subject';
import { first } from 'rxjs/internal/operators/first';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonService } from '../../../../common/services/common.service';
import * as formFactorsJSONData from './../../../../../assets/config/form-factors.json';
import { FormFactor, FormFactorsConfig } from '../../../../modules/asset-library/form-factors/interfaces/form-factors.i';
import { Utils } from '../../../../common/utils/utils';
import moment from 'moment';

@Component({
  selector: 'iposcen-attract-loop-popup',
  templateUrl: './attract-loop-popup.component.html',
  styleUrls: ['./attract-loop-popup.component.scss']
})
export class AttractLoopPopupComponent implements OnInit, OnDestroy {
  @ViewChild('attractLoopModal') modalContent: TemplateRef<AttractLoopPopupComponent>;
  @Output() readonly refreshAttractorLoopdata = new EventEmitter<any>();
  userId = sessionStorage.getItem('userId');
  videoFileName: string;
  fileTypeError: boolean;
  videoSizeErr: boolean;
  isUploadSuccess: boolean;
  isFormValid: boolean;
  attractorLoopPopupFrm: FormGroup;
  pageGrpForm: any;
  mediaObjects: any;
  videoFile: any;
  videoUrl: any;
  isVideoAvailable: boolean;
  customPublishDateResult: string;
  customExpiryDateResult: string;
  isPublishDateCustomDatepicker: boolean;
  isExpiryDatePicker: boolean;
  isSubmitted: boolean;
  selectedAttractorLoopId: string;
  formFactorSelectedAttract: FormFactor;
  buttonLabel: string;
  editCheck: boolean = false;
  isImgVideoSizeInfoEnabled: boolean;
  isCustomPublishDateCorrect: boolean;
  isCustomExpiryDateCorrect: boolean;
  isExpiredDateIncorrect: boolean;
  isPublishedDateInCorrect: boolean;
  segmentsForm: FormGroup;
  editexpiryDateInfo: string;
  editPublishDateInfo: string;
  divideDateFormat: boolean = true;
  selectedSegmentId: string;
  selectedFormFactors: FormFactor;
  iposBackgroundType: string;
  isEdit: boolean;
  allAttractorLoop: AttractorLoop[];
  configurations: AttractorLoopConfiguration[];
  displayAttractorLoop = [];
  internalNamePlaceholder = GlobalConstants.INTERNAL_NAME;
  publishedNamePlaceholder = GlobalConstants.PUBLISHED_NAME;
  saveSelectionText = GlobalConstants.SAVE_SELECTIONS;
  direction: string;
  url = AssetLibraryConstants.S3_ASSET_LIBRARY_USERS + this.userId
    + AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userId;
  isVideoSizeConstraintRemoved: boolean;
  videoLengthError: any;
  isVideoFormat: boolean;
  isVideo = false;
  isAttractLoopActive = true;
  defaultFormFactors: FormFactor;
  formManufacturers: FormGroup;
  formDeviceTypes: FormGroup;
  formProcessors: FormGroup;
  formGenerations: FormGroup;
  isAllManufacturersChecked: boolean;
  isAllDevicetypesChecked: boolean;
  isAllProcessorsChecked: boolean;
  selectAllProcDisabled: boolean = false;
  isAllGenerationsChecked: boolean;
  deviceTypesHeader = GlobalConstants.DEVICE_TYPES;
  manufacturersHeader = GlobalConstants.MANUFACTURERS;
  processorsHeader = GlobalConstants.PROCESSORS;
  generationsHeader = GlobalConstants.GENERATIONS;
  formFactorsJSONData: FormFactorsConfig = (formFactorsJSONData as any)
    .default;
  isNothingSelected = [false, false, false, false];
  isSelectionMade = false;
  errorColumns: string[] = [];
  circleTwo: string;
  circleOne: string;
  globalConstants: GlobalConstants
  private modalRef: NgbModalRef;
  private modalOption: NgbModalOptions = {};
  private ngUnsubscribe = new Subject<boolean>();
  isCustomPublishTimeZoneSelected = false;
  isCustomExpiryTimeZoneSelected = false;
  selectAll = GlobalConstants.SELECT_ALL_TEXT;
  deselectAll = GlobalConstants.DESELECT_ALL_TEXT;

  constructor(private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private attractorLoopService: AttractorLoopService,
    private sanitizer: DomSanitizer,
    private commonService: CommonService) { }

  ngOnInit(): void {
    this.direction = this.commonService.direction;
    this.isVideoSizeConstraintRemoved = this.commonService.isSizeContraintsEnabled;
    this.isFormValid = false;
    this.createAttractorLoopGroupForm();
    this.initializeFormFactor();
    this.videoFileName = '';
    this.fileTypeError = false;
    this.videoSizeErr = false;
    this.isUploadSuccess = false;
    this.isVideoAvailable = true;
    this.customPublishDateResult = GlobalConstants.NOW;
    this.customExpiryDateResult = GlobalConstants.NEVER;
    this.isExpiredDateIncorrect = false;
	  this.isCustomPublishDateCorrect = false;
    this.isCustomExpiryDateCorrect = false;
    this.isPublishDateCustomDatepicker = false;
    this.isExpiryDatePicker = false;
    this.mediaObjects = {
      media: {
        videoFile: '',
        url: '',
        format: '',
        fileObj: ''
      }
    };
  }

  initializeFormFactor() {
    this.defaultFormFactors = {
      allDevices: true,
      devices: GlobalConstants.ALL,
      manufacturer: GlobalConstants.ALL,
      processors: GlobalConstants.ALL,
      generations: GlobalConstants.ALL
    };
    this.defaultFormFactors = JSON.parse(JSON.stringify(this.defaultFormFactors));
    this.addFFCheckboxes();
    this.initalizeFormFactorOnChange();
  }

  addFFCheckboxes() {
    this.initializeFFFormArrays();
    if (this.defaultFormFactors.devices === GlobalConstants.ALL) {
      this.isAllDevicetypesChecked = true;
      this.formFactorsJSONData.deviceTypes.forEach(deviceType => {
        if (deviceType) {
          this.deviceTypesArray.push(new FormControl(true));
        }
      });
    }
    if (this.defaultFormFactors.manufacturer === GlobalConstants.ALL) {
      this.isAllManufacturersChecked = true;
      this.formFactorsJSONData.manufacturers.forEach(manufacturer => {
        if (manufacturer) {
          this.manufacturersArray.push(new FormControl(true));
        }
      });
    }
    if (this.defaultFormFactors.processors === GlobalConstants.ALL) {
      this.isAllProcessorsChecked = false;
      this.formFactorsJSONData.processors.forEach(processor => {
        if (processor.name !== GlobalConstants.NON_INTEL) {
          if (processor.name === GlobalConstants.CELERON || processor.name === GlobalConstants.PENTIUM || processor.name === GlobalConstants.INTEL_PROCESSOR) {
            this.processorsArray.push(new FormControl(false));
          } else this.processorsArray.push(new FormControl(true));
        }
      });
    }
    if (this.defaultFormFactors.generations === GlobalConstants.ALL) {
      this.isAllGenerationsChecked = true;
      this.formFactorsJSONData.generation.forEach(generations => {
        if (generations) {
          this.generationsArray.push(new FormControl(true));
        }
      });
    }

  }

  initalizeFormFactorOnChange() {
    this.formDeviceTypes.get('deviceTypes')
      .valueChanges
      .subscribe(value => {
        this.isAllDevicetypesChecked = value.every(val => val);
        this.isNothingSelected[0] = value.every(val => !val) ? true : false;
        this.isSelectionMade = false;
      });
    this.formManufacturers.get('manufacturers').valueChanges
      .subscribe(value => {
        this.isAllManufacturersChecked = value.every(val => val);
        this.isNothingSelected[1] = value.every(val => !val) ? true : false;
        this.isSelectionMade = false;
      });
    this.formProcessors.get('processors').valueChanges
      .subscribe(value => {
        this.isAllProcessorsChecked = value.every(val => val);
        this.isNothingSelected[2] = value.every(val => !val) ? true : false;
        this.isSelectionMade = false;
      });
    this.formGenerations.get('generations').valueChanges
      .subscribe(value => {
        this.isAllGenerationsChecked = value.every(val => val);
        this.isNothingSelected[3] = value.every(val => !val) ? true : false;
        this.isSelectionMade = false;
      });
  }

  initializeFFFormArrays() {
    this.formManufacturers = this.formBuilder.group({
      manufacturers: new FormArray([])
    });
    this.formDeviceTypes = this.formBuilder.group({
      deviceTypes: new FormArray([])
    });
    this.formProcessors = this.formBuilder.group({
      processors: new FormArray([])
    });
    this.formGenerations = this.formBuilder.group({
      generations: new FormArray([])
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  createAttractorLoopGroupForm() {
    // TODO -- need to add validations for form fields
    this.attractorLoopPopupFrm = this.formBuilder.group({
      publishedName: new FormControl(''),
      internalName: new FormControl(''),
      uploadedVideoName: new FormControl('')
    });
    this.videoFile = '';
  }

  open() {
    this.isPublishDateCustomDatepicker = false;
    this.isExpiryDatePicker = false;
    this.initializeFormFactor();
    this.isSelectionMade = false;
    this.isAttractLoopActive = true;
    this.videoFileName = '';
    this.fileTypeError = false;
    this.videoSizeErr = false;
    this.videoLengthError = false;
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalRef = this.modalService.open(this.modalContent, this.modalOption);
    this.modalRef.result.then(
      reason => {
      }
    );
  }

  close() {
    this.isPublishDateCustomDatepicker = false;
    this.isExpiryDatePicker = false;
    this.createAttractorLoopGroupForm();
    this.modalRef.close();
  }

  dismiss() {
    this.isPublishDateCustomDatepicker = false;
    this.isExpiryDatePicker = false;
    this.createAttractorLoopGroupForm();
    this.initializeFormFactor();
    this.isSelectionMade = false;
    this.modalRef.dismiss();
  }

  readVideoUrl(event: any) {
    if (event.target.files.length > 0) {
      this.videoFile = event.target.files[0];
      this.videoFileName = this.videoFile.name;
      const reader = new FileReader();
      const fileType: string = this.videoFile?.type;
      const fileSize: number = this.videoFile?.size;
      this.fileTypeError = fileType !== GlobalConstants.FILE_TYPE_VIDEO_MP4;
      if (!this.fileTypeError) {
        reader.readAsDataURL(this.videoFile);
        reader.onload = _event => {
          let video = document.createElement('video');
          video.preload = 'metadata';
          video.src = _event.target.result.toString();
          video.onloadedmetadata = () => {
            if (this.isVideoSizeConstraintRemoved) this.videoLengthError = this.videoSizeErr = false;
            else {
              this.videoLengthError = video.duration > GlobalConstants.UPLOAD_VIDEO_MAX_TIME;
              this.videoSizeErr = fileSize > GlobalConstants.UPLOAD_VIDEO_MAX_SIZE;
            }
            this.isVideo = !(this.fileTypeError || this.videoSizeErr || this.videoLengthError);
            if (this.isVideo) {
              this.videoUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(this.videoFile));
            }
          }
        }
      } else {
        this.isVideo = !this.fileTypeError;
        this.videoLengthError = this.videoSizeErr = false;
      }
    }
  }

  getAllAttractorLoopByUser() {
    this.attractorLoopService.getAllAttractorLoopByUser()
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(getAllAttractorLoopResponse => {
        this.allAttractorLoop = (getAllAttractorLoopResponse.attractLoop as AttractorLoop[]);
        this.configurations = [];
        this.allAttractorLoop.forEach(attractorLoopGroup => {
          this.configurations.push(JSON.parse(attractorLoopGroup.configurations) as AttractorLoopConfiguration);
        });

        // display Attractor loop using displayAttractorLoop var as configurations is coming as string
        this.displayAttractorLoop = [];
        this.allAttractorLoop.forEach(ele => {
          ele.configurations = JSON.parse(ele.configurations);
          ele.createdByUser = (ele.createdByUser === this.userId) ? GlobalConstants.ME : ele.createdByUser;
          this.displayAttractorLoop.push(ele);
        });
        this.displayAttractorLoop.forEach(element => {
          element.isExpanded = false;
        });
      },
        () => {
          // do something
        });
  }
  checkExpiryDateTime() {
    if (this.customExpiryDateResult !== GlobalConstants.NEVER) {
      this.isExpiredDateIncorrect = Utils.customDateCheck(this.customPublishDateResult, this.customExpiryDateResult);
    }
  }
  checkPublishedDateTime() {
    this.isSubmitted = false;
    let isPublishedDateSmaller;
    //need to check a condition based on upcoming implementation
    // if (this.attractorLoopPopupFrm.controls.publishdate.toString() !== '') {
    //   isPublishedDateSmaller = new Date(this.attractorLoopPopupFrm.controls.publishdate.value).getTime() < new Date().getTime();
    // }
    // this.isPublishedDateInCorrect = isPublishedDateSmaller;
    }
  customValidation() {
    if (this.isPublishDateCustomDatepicker) {
      this.isCustomPublishDateCorrect = (this.customPublishDateResult === GlobalConstants.NOW);
    }
    if (this.isExpiryDatePicker) {
      this.isCustomExpiryDateCorrect = (this.customExpiryDateResult === GlobalConstants.NEVER);
    }
  }

  onAdd() {
    this.customValidation();
    this.checkExpiryDateTime();
    this.checkPublishedDateTime();
    this.isFormValid = this.attractorLoopPopupFrm?.controls?.publishedName?.value.trim() !== '';
    const attractLoopFormFactor: FormFactor = Utils.getFormFactorValues(this.defaultFormFactors);
    if (this.isFormValid && !this.isExpiredDateIncorrect && !this.isCustomExpiryDateCorrect && !this.isCustomPublishDateCorrect &&
        !this.isCustomPublishTimeZoneSelected && !this.isCustomExpiryTimeZoneSelected) {
      const attractorLoop: AttractorLoopConfiguration = {
        publishedName: this.attractorLoopPopupFrm.controls.publishedName.value.trim(),
        internalName: this.attractorLoopPopupFrm.controls.internalName.value,
        publishTime: (this.customPublishDateResult.toString() !== GlobalConstants.NOW) ?
        this.customPublishDateResult.toString() : Utils.getCurrentDate(),
        expireTime: (this.customExpiryDateResult.toString() !== GlobalConstants.NEVER) ?
        this.customExpiryDateResult.toString() : GlobalConstants.NEVER,
        uploadedVideoName: this.videoFileName,
        isPublishDateNow: !this.isPublishDateCustomDatepicker,
        isPublishExpiryNever: !this.isExpiryDatePicker,
        formFactor: attractLoopFormFactor
      };
      if(attractorLoop.expireTime !== GlobalConstants.NEVER ){
        attractorLoop.expireTime = Utils.changeSaveDateFormat(attractorLoop.expireTime);
      }
      if(!attractorLoop.isPublishDateNow){
        attractorLoop.publishTime = Utils.changeSaveDateFormat(attractorLoop.publishTime);
      }
      this.attractorLoopService.createAttractorLoop(JSON.stringify(attractorLoop))
        .pipe(takeUntil(this.ngUnsubscribe))
        .pipe(first())
        .subscribe(createAttractorLoopResponse => {
          this.mediaObjects = [];
          const dataObj = {
            id: createAttractorLoopResponse.attractLoop.id,
            media: {
              videoFile: this.videoFile,
              url: this.videoUrl,
              format: this.videoFile.type,
              fileObj: this.videoFile.name
            }
          };
          this.mediaObjects.push(dataObj);
          this.modalRef.close();
          this.attractorLoopService.uploadVideo(this.mediaObjects[0].media.videoFile,
            this.mediaObjects[0].media.format, this.mediaObjects[0].id)
            .pipe(takeUntil(this.ngUnsubscribe))
            .pipe(first())
            .subscribe(() => {
              this.createAttractorLoopGroupForm();
              this.commonService.emitRefreshProfileAttractLoop(createAttractorLoopResponse.attractLoop.id);
            },
              () => { // do something
              }
            );
        },
          () => {

          });
    }
  }

  selectFormFactors() {
    this.isFormValid = this.attractorLoopPopupFrm?.controls?.publishedName?.value.trim() !== '' && this.isVideo;
    if(!this.isExpiredDateIncorrect || !this.isCustomExpiryDateCorrect || !this.isCustomPublishDateCorrect){
    this.isAttractLoopActive = false;
    }
  }

  setAllValuesTrue(formArray: FormArray) {
    for (let control of formArray.controls) {
      if (control instanceof FormControl) {
        control.patchValue(true, { emitEvent: false });
      }
    }
  }

  setAllValuesFalse(formArray: FormArray) {
    for (let control of formArray.controls) {
      if (control instanceof FormControl) {
        control.patchValue(false, { emitEvent: false });
      }
    }
  }
  selectCustomPublishDate(datetimeOption) {
    this.isPublishDateCustomDatepicker = this.checkStatus(datetimeOption);
    if (!this.isPublishDateCustomDatepicker && this.customPublishDateResult !== GlobalConstants.NOW) {
      this.customPublishDateResult = Utils.getCurrentDate();
    }
    if (datetimeOption === GlobalConstants.NOW) {
      this.isCustomPublishDateCorrect = false;
      this.isCustomPublishTimeZoneSelected = false;
    }
  }
  selectExpiryDateTimeZone(datetimeOption) {
    this.isExpiryDatePicker = this.checkStatus(datetimeOption);
    if (!this.isExpiryDatePicker && this.customExpiryDateResult !== GlobalConstants.NEVER) {
      this.customExpiryDateResult = GlobalConstants.NEVER;
    }
    if (datetimeOption === GlobalConstants.NEVER) {
      this.isExpiredDateIncorrect = false;
      this.isCustomExpiryDateCorrect = false;
      this.isCustomExpiryTimeZoneSelected = false;
    }
  }
  checkStatus(status) {
    return (status === GlobalConstants.CUSTOM);
  }
  get manufacturersArray() {
    return this.formManufacturers.controls.manufacturers as FormArray;
  }

  get deviceTypesArray() {
    return this.formDeviceTypes.controls.deviceTypes as FormArray;
  }

  get processorsArray() {
    return this.formProcessors.controls.processors as FormArray;
  }

  get generationsArray() {
    return this.formGenerations.controls.generations as FormArray;
  }

  isAnySingleOptionSelected() {
    this.isNothingSelected[1] =
      this.formManufacturers.value.manufacturers.every(val => !val) ? true : false;
    this.isNothingSelected[0] =
      this.formDeviceTypes.value.deviceTypes.every(val => !val) ? true : false;
    this.isNothingSelected[2] =
      this.formProcessors.value.processors.every(val => !val) ? true : false;
    this.isNothingSelected[3] =
      this.formGenerations.value.generations.every(val => !val) ? true : false;
  }

  isNoSelectionMade() {
    this.isSelectionMade = this.isNothingSelected.includes(true) ? true : false;
    return this.isSelectionMade;
  }

  onSelectAllFormFactorsChange(event, formFactorType: string) {
    this.isSelectionMade = false;
    switch (formFactorType) {
      case 'Device Types': {
        if (event.target.checked) {
          this.isAllDevicetypesChecked = true;
          this.setAllValuesTrue(this.deviceTypesArray);
        } else {
          this.isAllDevicetypesChecked = false;
          this.setAllValuesFalse(this.deviceTypesArray);
          this.isAnySingleOptionSelected();
        }
        break;
      }
      case 'Manufacturers': {
        if (event.target.checked) {
          this.isAllManufacturersChecked = true;
          this.setAllValuesTrue(this.manufacturersArray);
        } else {
          this.isAllManufacturersChecked = false;
          this.setAllValuesFalse(this.manufacturersArray);
          this.isAnySingleOptionSelected();
        }
        break;
      }
      case 'Processors': {
        if (event.target.checked) {
          this.isAllProcessorsChecked = true;
          this.setAllValuesTrue(this.processorsArray);
        } else {
          this.isAllProcessorsChecked = false;
          this.setAllValuesFalse(this.processorsArray);
          this.isAnySingleOptionSelected();
        }
        break;
      }
      case 'Generations': {
        if (event.target.checked) {
          this.isAllGenerationsChecked = true;
          this.setAllValuesTrue(this.generationsArray);
        } else {
          this.isAllGenerationsChecked = false;
          this.setAllValuesFalse(this.generationsArray);
          this.isAnySingleOptionSelected();
        }
        break;
      }

      default:
        break;
    }
  }


  loadMiniPreview(gId: string) {
    this.pageGrpForm = {
      bgcolor: '#ffffff',
      heading: ' ',
      hcolor: '#ffffff',
      body: ' ',
      bcolor: '#ffffff',
      size: GlobalConstants.MEDIUM,
      media: {
        url:
          environment.apiBaseUrlAsset + this.url +
          AssetLibraryConstants.ATTRACTOR_LOOP +
          AssetLibraryConstants.SLASH +
          gId,
        name: '',
        format: 'video',
        fileObj: ''
      },
      id: gId, // adding created group id,
      layout: 3
    };

    return this.pageGrpForm;
  }

  switchToAttractLoopTab() {
    this.isAttractLoopActive = true;
    if(this.isPublishDateCustomDatepicker){
      this.editPublishDateInfo = this.customPublishDateResult;
    }
    if(this.isExpiryDatePicker){
      this.editexpiryDateInfo = this.customExpiryDateResult;
    }
    this.isCustomPublishTimeZoneSelected = false;
    this.isCustomExpiryTimeZoneSelected = false;
  }

  switchtoFFTab() {
    this.isFormValid = this.attractorLoopPopupFrm?.controls?.publishedName?.value.trim() !== '' && this.isVideo;
    this.isAttractLoopActive = false;
    }

  checkAllSelectionClicked(types: any, typeData: any) {
    let selectedType;
    if (!types.every(val => val)) {
      selectedType = types
        .map((checked, i) => (checked ? typeData[i].name : null))
        .filter(v => v !== null)
        .join(', ');
    } else {
      selectedType = [GlobalConstants.ALL].join(',');
    }
    return selectedType;
  }

  getFFName(index: number): string {
    let name = '';
    switch (index) {
      case 0:
        name = GlobalConstants.DEVICE_TYPE;
        break;
      case 1:
        name = GlobalConstants.MANUFACTURER;
        break;
      case 2:
        name = GlobalConstants.PROCESSOR;
        break;
      case 3:
        name = GlobalConstants.GENERATION;
        break;
      default:
        name = '';
        break;
    }

    return name;
  }
  checkIfTimeset(data, check) {
    if (check === 'publish') {
      if (data[0] && data[1]) {
        this.isCustomPublishDateCorrect = false;
      }
    } else {
      if (data[0] && data[1]) {
        this.isCustomExpiryDateCorrect = false;
      }
    }
  }
  getLogoContentPublishDate(data) {
    this.customPublishDateResult = this.generateDateTimeZone(data);
  }
  getLogoContentExpiryDate(data) {
    this.customExpiryDateResult = this.generateDateTimeZone(data);
  }
  generateDateTimeZone(data) {
    return `${moment(data.dateVal).format(GlobalConstants.DATE_FORMAT)} ${data.hour}:${data.min} ${data.timeZone}`;
  }

  saveAttractLoopVideo() {
    this.isAnySingleOptionSelected();
    if (!this.isNoSelectionMade()) {
      const selectedManufacturers = this.checkAllSelectionClicked(
        this.formManufacturers.value.manufacturers,
        this.formFactorsJSONData.manufacturers
      );
      const selectedDeviceTypes = this.checkAllSelectionClicked(
        this.formDeviceTypes.value.deviceTypes,
        this.formFactorsJSONData.deviceTypes
      );
      const selectedProcessors = this.checkAllSelectionClicked(
        this.formProcessors.getRawValue().processors,
        this.formFactorsJSONData.processors
      );
      const selectedGenerations = this.checkAllSelectionClicked(
        this.formGenerations.value.generations,
        this.formFactorsJSONData.generation
      );
      const isAllFormFactorSelected = (selectedDeviceTypes === GlobalConstants.ALL &&
        selectedManufacturers === GlobalConstants.ALL && selectedProcessors === GlobalConstants.ALL &&
        selectedGenerations === GlobalConstants.ALL) ? true : false;
      this.isSelectionMade = false;
      this.defaultFormFactors = {
        allDevices: isAllFormFactorSelected,
        devices: selectedDeviceTypes,
        manufacturer: selectedManufacturers,
        processors: selectedProcessors,
        generations: selectedGenerations
      };
      this.onAdd();
    } else {
      this.errorColumns = [];
      this.isNothingSelected.forEach((value, index) => {
        if (value) {
          this.errorColumns.push(this.getFFName(index));
        }
      });

    }
  }

  checkTimeZone(data, check) {
    (check === GlobalConstants.PUBLISH) ? (this.isCustomPublishTimeZoneSelected = !data) : (this.isCustomExpiryTimeZoneSelected = !data);
  }
}
